import { Villa, VillaStatus, VillasResponse } from './types';

// Cloudflare Tunnel URL для API
const API_BASE = 'https://pens-collectables-funk-newspapers.trycloudflare.com/api';

export async function fetchVillas(): Promise<VillasResponse> {
  const res = await fetch(`${API_BASE}/villas`);
  if (!res.ok) throw new Error('Failed to fetch villas');
  return res.json();
}

export async function fetchArchived(): Promise<VillasResponse> {
  const res = await fetch(`${API_BASE}/villas/archived`);
  if (!res.ok) throw new Error('Failed to fetch archived');
  return res.json();
}

export async function fetchVilla(id: string): Promise<Villa> {
  const res = await fetch(`${API_BASE}/villas/${id}`);
  if (!res.ok) throw new Error('Failed to fetch villa');
  return res.json();
}

export async function updateVilla(
  id: string,
  data: Partial<{
    status: VillaStatus;
    pinned: boolean;
    phone: string;
    comment: string;
    price: number;
  }>
): Promise<Villa> {
  const res = await fetch(`${API_BASE}/villas/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Failed to update villa');
  return res.json();
}

export async function togglePin(id: string, pinned: boolean): Promise<Villa> {
  const res = await fetch(`${API_BASE}/villas/${id}/pin`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ pinned }),
  });
  if (!res.ok) throw new Error('Failed to update pin');
  return res.json();
}

export async function deleteVilla(id: string): Promise<void> {
  const res = await fetch(`${API_BASE}/villas/${id}`, {
    method: 'DELETE',
  });
  if (!res.ok) throw new Error('Failed to delete villa');
}

// Normalize phone to +62 format
export function normalizePhone(phone: string): string {
  let cleaned = phone.replace(/\D/g, '');

  // Remove leading 0, add +62
  if (cleaned.startsWith('0')) {
    cleaned = '62' + cleaned.slice(1);
  } else if (!cleaned.startsWith('62')) {
    cleaned = '62' + cleaned;
  }

  return '+' + cleaned;
}

// Format phone for display
export function formatPhone(phone: string): string {
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.startsWith('62') && cleaned.length > 10) {
    return `+${cleaned.slice(0, 2)} ${cleaned.slice(2, 5)} ${cleaned.slice(5, 9)} ${cleaned.slice(9)}`;
  }
  return '+' + cleaned;
}

// Create WhatsApp link
export function createWhatsAppLink(phone: string): string {
  const normalized = normalizePhone(phone);
  return `https://wa.me/${normalized.replace(/\+/g, '')}`;
}

// Extract domain for display
export function extractDomain(url: string): string {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.replace('www.', '');
  } catch {
    return url;
  }
}
